import { Component, OnInit, inject, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms'; // Importa FormsModule
import { CommonModule, formatDate } from '@angular/common';
import { DomSanitizer, SafeResourceUrl   } from "@angular/platform-browser";
import { NgbDatepickerModule, NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormArray, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { ModalComponent } from "../../../modal/modal.component";
import { InicioService } from '../../../../services/inicio.service';
import { UsuarioService } from '../../../../services/usuario.service';
import { I18n, CustomDatepickerI18n } from '../../../../clases/idioma-fecha';
import { appsettings } from '../../../../settings/appsettings';

@Component({
  selector: 'app-editar',
  standalone: true,
  imports: [ModalComponent, CommonModule, FormsModule, NgbDatepickerModule, ReactiveFormsModule, NgxMaskDirective],
  templateUrl: './editar.component.html',
  styleUrl: './editar.component.css',
  providers: [
    provideNgxMask(),
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }
  ],
})
export class EditarComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  @Input() id_institucional?: any;
  @Input() id_rol?: any;
  @Input() nombre_institucional?: any;
  @Output() vuelve = new EventEmitter<any>();
  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;
  user: any;
  errorMessage: string = '';

  validaTipoRol: boolean = true;

  txtComponente: string = 'Cargar .PDF';
  txtSintesis: string = 'Cargar .PDF';
  txtCedula: string = 'Cargar .PDF';

  valComponente: SafeResourceUrl | null = null;
  valSintesis: SafeResourceUrl | null = null;
  valCedula: SafeResourceUrl | null = null;

  institucional: any = [];
  documentos: any = [];
  rol: any = [];
  tipo_formador: any = [];
  gerencias: any = [];
  cargo: any = [];
  sexo: any = [];
  estado_civil: any = [];
  grado_instruccion: any = [];
  estado: any = [];
  operadora_movil: any = [];


  private srvLogin = inject(InicioService);
  private servicios = inject(UsuarioService);
  private sanitizer = inject(DomSanitizer);
  private fb = inject(FormBuilder)
  private url = appsettings.apiUrl;

  formularioRegistro: FormGroup;


  constructor( ){
    this.formularioRegistro = this.fb.group({
      //---- datos_institucional ----
      frm_id_rol: ['', Validators.required],
      frm_id_tipo_formador: [''],
      frm_contrasena: [''],
      frm_confirma_contrasena: [''],
      frm_id_gerencia: ['',Validators.required],
      frm_id_cargo: ['',Validators.required],
      frm_fecha_ingreso: ['', Validators.required],
      frm_correo: ['', Validators.required],
      //---- datos_personales ----
      frm_nombre: ['', Validators.required],
      frm_apellido: ['', Validators.required],
      frm_nro_doc: [''],//
      frm_identificacion: ['', Validators.required],
      frm_fecha_nacimiento: [''],//
      frm_nivel_academico: ['', Validators.required],
      frm_edo_civil: ['', Validators.required],
      frm_genero: ['', Validators.required],
      frm_carnet_patria: [''],//
      //---- datos_contacto ----
      frm_telefono: ['', Validators.required],
      frm_correo_alternativo: ['', Validators.required],
      frm_estado: ['', Validators.required],
      frm_dirreccion: ['', Validators.required],
    });
  }



  ngOnInit(): void {
    this.srvLogin.user$.subscribe(user => { this.user = user; });
  }

  ngAfterViewInit(): void {
    this.mdl.cargando();
    this.servicios.seleccionarInstitucional(this.id_institucional).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.institucional = rs.data.institucional[0];
        this.documentos = rs.data.documentos;
        this.rol = rs.data.rol;
        this.tipo_formador = rs.data.tipo_formador;
        this.gerencias = rs.data.gerencias;
        this.cargo = rs.data.cargo;
        this.sexo = rs.data.sexo;
        this.estado_civil = rs.data.estado_civil;
        this.grado_instruccion = rs.data.grado_instruccion;
        this.estado = rs.data.estado;
        this.validaTipoRol = this.institucional.id_rol == 11 ? true : false;
        console.table('prueba estudiante:   ',this.institucional);
        console.table('rol:   ',this.institucional.id_rol);
        console.table('prueba documentos:   ',rs.data.documento);

        if(rs.data.documento > 0 ){
          let arr: any[] =[];
          (rs.data.documento).forEach((e:any) => {arr.push((e.todo).split("|")[0]) });
          this.valComponente = arr.indexOf('1') == -1 ? null : this.transform(`${this.url}${(rs.data.documento[arr.indexOf('1')].todo).split("|")[1]}`);
          this.valSintesis = arr.indexOf('2') == -1 ? null : this.transform(`${this.url}${(rs.data.documento[arr.indexOf('2')].todo).split("|")[1]}`);
          this.valCedula = arr.indexOf('3') == -1 ? null : this.transform(`${this.url}${(rs.data.documento[arr.indexOf('3')].todo).split("|")[1]}`);
          arr = [];
          (rs.data.documento).forEach((e:any) => {arr.push((e.nombre_pdf).split("|")[0]) });
          this.txtComponente = arr.indexOf('1') == -1 ? 'Cargar .PDF' : (rs.data.documento[arr.indexOf('1')].nombre_pdf).split("|")[1]
          this.txtSintesis = arr.indexOf('2') == -1 ? 'Cargar .PDF' : (rs.data.documento[arr.indexOf('2')].nombre_pdf).split("|")[1]
          this.txtCedula = arr.indexOf('3') == -1 ? 'Cargar .PDF' : (rs.data.documento[arr.indexOf('3')].nombre_pdf).split("|")[1]
        }
        this.formularioRegistro.patchValue({
          frm_id_rol: this.institucional['id_rol'],
          frm_id_tipo_formador: this.institucional['id_tipo_formador'],
          frm_id_gerencia: this.institucional['id_gerencia'],
          frm_id_cargo: this.institucional['id_cargo'],
          frm_fecha_ingreso: this.convierteDtpick(formatDate(this.institucional['fecha_ingreso'], 'dd-MM-yyyy', 'en-US')),
          frm_correo: this.institucional['correo'],

          frm_nombre: this.institucional['nombre'],
          frm_apellido: this.institucional['apellido'],
          frm_nro_doc: this.institucional['tipo_documento'],
          frm_identificacion: this.institucional['identificacion'],
          frm_fecha_nacimiento: this.convierteDtpick(formatDate(this.institucional['fecha_nacimiento'], 'dd-MM-yyyy', 'en-US')),
          frm_nivel_academico: this.institucional['id_nivel_academico'],
          frm_edo_civil: this.institucional['id_estado_civil'],
          frm_genero: this.institucional['id_sexo'],
          frm_carnet_patria: this.institucional['codigo_patria'],

          frm_telefono: this.institucional['telefono_movil'],
          frm_correo_alternativo: this.institucional['correo_personal'],
          frm_estado: this.institucional['id_estado'],
          frm_dirreccion: this.institucional['direccion']
        })

      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  cambia(tipo: number, event: any){
    const input = event.target as HTMLInputElement;
    if(tipo == 1){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          // 1. Crear la URL del objeto
          //this.rawObjectUrl = URL.createObjectURL(input.files[0]);
          // 2. Sanitizar la URL para que Angular la considere segura
          // Para iframes, usamos bypassSecurityTrustResourceUrl
          this.valComponente = this.transform(URL.createObjectURL(input.files[0]));
          this.txtComponente = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });
          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.institucional['identificacion'],
            "tipo": tipo,
            "archivo": blob
          }
          //console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));
          console.log('datos a enviar:   ', envio);
          this.subir_archivo(envio);

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 2){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valSintesis = this.transform(URL.createObjectURL(input.files[0]));
          this.txtSintesis = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });
          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.institucional['identificacion'],
            "tipo": tipo,
            "archivo": blob
          }
          this.subir_archivo(envio);
          console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));
        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 3){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valCedula = this.transform(URL.createObjectURL(input.files[0]));
          this.txtCedula = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });
          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.institucional['identificacion'],
            "tipo": tipo,
            "archivo": blob
          }
          this.subir_archivo(envio);
          console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }

  }

  valida(eve: any){
    let id_rol = eve.value
    this.validaTipoRol = id_rol == 11 ? true : false;
  }

  transform(url: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  convierteDtpick(date: string):NgbDateStruct {
    let array = date.split("-");
    return {year: parseInt(array[2]), month: parseInt(array[1]), day: parseInt(array[0])};
  }

  ver_pass(tipo: number){
    let pass = tipo == 1 ? (document.getElementById('contrasena') as HTMLInputElement) : (document.getElementById('confirma_contrasena') as HTMLInputElement);
    pass.getAttribute('type') == 'password' ? pass.setAttribute('type', 'text') : pass.setAttribute('type', 'password');
  }

  convertidor(numero: number): string {
    return numero < 10 ? `0${numero}` : numero.toString();
  }


  guardar_todo(){
    let passRegex = /^(?=.*[!@#$%^&*(),.?":{}|<>])(?=.*\d)(?=.*[a-z]).{8,}$/;
    let pass = this.formularioRegistro.get('frm_contrasena')?.getRawValue();
    let valor: boolean = true;
    if(!this.formularioRegistro.valid){
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = "Debe completar los campos requeridos del formulario (*)";
      this.mdl.alerta();
      valor = false;
    }
    else if(pass != '' || this.formularioRegistro.get('frm_confirma_contrasena')?.getRawValue() != ''){
      if(!passRegex.test(pass)){
        this.titulo = '!ADVERTENCIA¡';
        this.tipo_color = 'warning';
        this.letra_color = 'dark';
        //this.mensaje = "La contraseña no cumple con las características de validación. Por favor presione el botón de ('Indicaciones para crear la contraseña...') ";
        this.mensaje = "La contraseña no cumple con las características de validación.";
        this.mdl.alerta();
        valor = false;
      }else if(pass != this.formularioRegistro.get('frm_confirma_contrasena')?.getRawValue()){
        this.titulo = '!ADVERTENCIA¡';
        this.tipo_color = 'warning';
        this.letra_color = 'dark';
        this.mensaje = "Las contraseñas deben ser iguales";
        this.mdl.alerta();
        valor = false;
      }
      else{
        valor = true;
      }
    }
    else{
      valor = true;
    }
    if(valor){
      //aplica solo caundo se va a enviar en vista de que si no se ejecuta el
      //servicio da error ya que modificamos las variables del formGroup
      let fch_nac = this.formularioRegistro.get('frm_fecha_nacimiento')?.getRawValue();
      let fch = `${this.convertidor(fch_nac['year'])}-${this.convertidor(fch_nac['month'])}-${this.convertidor(fch_nac['day'])}`
      let fch_ing = this.formularioRegistro.get('frm_fecha_ingreso')?.getRawValue();
      let fch2 = `${this.convertidor(fch_ing['year'])}-${this.convertidor(fch_ing['month'])}-${this.convertidor(fch_ing['day'])}`
      this.formularioRegistro.get('frm_fecha_nacimiento')?.setValue(fch);
      this.formularioRegistro.get('frm_fecha_ingreso')?.setValue(fch2);
      Object.assign(this.formularioRegistro.value, {'id_institucional': this.id_institucional});
      console.log('todos: ', this.formularioRegistro.value)
      this.mdl.cargando();
      this.servicios.updateInstitucional(this.formularioRegistro.value).subscribe({
        next: (rs) => {
          this.mdl.cerrar();
          this.vuelve.emit({value: false, validador: true});
        },
        error: (error) => {
          this.errorMessage = error.message; // Muestra el mensaje de error al usuario
          //console.error("Error en el componente:", error); // Registro del error en el componente
        }
      });
    }
  }

  subir_archivo(datos: any){
    this.servicios.subir_archivo_institucional(datos).subscribe({
      next: (rs) => {
        this.titulo = '!EXITO¡';
        this.tipo_color = 'success';
        this.letra_color = 'light';
        this.mensaje = 'Archivo cargado con exito.';
        this.mdl.alerta();
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }


  volver(){
    this.vuelve.emit({value: false, validador: false});
  }
}
